'use strict';

module.exports = {
    LANG: 'iw-il',
    SIGN: 'רישום',
    REGISTER: 'הירשם',
    QUICK_ACCESS: 'גישה מהירה עם',
    SIGN_JOIN: 'הירשמו או הצטרפו בחינם!',
    NOT_MEMBER: 'אין לכם שם משתמש באתר?',
    ALREADY_MEMBER: 'יש לכם כבר שם משתמש באתרי AliExpress/Alibaba?',
    SHOW_ALL: 'להראות כל',
    HIDE: 'הסתר'
};